import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { Divider } from '@material-ui/core'
import {styles} from '../../CSS/Styles'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Checkbox from '@material-ui/core/Checkbox'
import Grid from '@material-ui/core/Grid'
import SimpleSelect from '../../CSSComponent/dropdownselection'
import Button from '@material-ui/core/Button'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";

const theme = createMuiTheme({
  overrides: {
    MuiInput: {
      underline: {
        "&&&&:before": {
            borderBottom: "0px solid rgba(0, 0, 0, 0)"
        },
        "&&&&:hover:before": {
          borderBottom: "0px solid rgba(0, 0, 0, 0)"
        }
      }
    }
  }
});
class KRI extends React.Component {

    constructor(props) {
        super(props)
        //console.log(this.props.kri)
        let riskTolerances = this.props.riskTolerance
        let riskToleranceNo = []
        let riskToleranceDescription = []
        let riskToleranceOwner=[]
        let riskTolerancevalue =[]
        for (let itemindex in riskTolerances) {
            let item = riskTolerances[itemindex]
            riskToleranceNo.push(item.risk_tolerance_id)
            riskToleranceDescription.push(item.risk_tolerance_description)
            riskToleranceOwner.push(item.risk_tolerance_owner)
            riskTolerancevalue.push(item.risk_tolerance_tolerance)
        }
        this.state = {
            'No': this.props.No,
            'V. Low': this.props.VLow,
            'Low': this.props.Low,
            'Medium': this.props.Medium,
            'High': this.props.High,
            'RiskAppetiteStatement': this.props.RiskAppetiteStatement,
            'AppetiteToleranceCheckBox': {'': ['No', 'V. Low', 'Low', 'Medium', 'High']},
            'RiskTolerance': this.props.riskTolerance,
            'riskToleranceNo': riskToleranceNo,
            'riskToleranceDescription': riskToleranceDescription,
            'riskToleranceOwner': riskToleranceOwner,
            'riskTolerancevalue': riskTolerancevalue,
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("new id : " + this.props.queryID + "vs old id : " + prevProps.queryID);
        if (this.props != prevProps) {
            let riskTolerances = this.props.riskTolerance
            let riskToleranceNo = []
            let riskToleranceDescription = []
            let riskToleranceOwner=[]
            let riskTolerancevalue =[]
            for (let itemindex in riskTolerances) {
                let item = riskTolerances[itemindex]
                riskToleranceNo.push(item.risk_tolerance_id)
                riskToleranceDescription.push(item.risk_tolerance_description)
                riskToleranceOwner.push(item.risk_tolerance_owner)
                riskTolerancevalue.push(item.risk_tolerance_tolerance)
            }
            this.setState({
                'No': this.props.No,
                'V. Low': this.props.VLow,
                'Low': this.props.Low,
                'Medium': this.props.Medium,
                'High': this.props.High,
                'RiskAppetiteStatement': this.props.RiskAppetiteStatement,
                'AppetiteToleranceCheckBox': {'': ['No', 'V. Low', 'Low', 'Medium', 'High']},
                'RiskTolerance': this.props.riskTolerance,
                'riskToleranceNo': riskToleranceNo,
                'riskToleranceDescription': riskToleranceDescription,
                'riskToleranceOwner': riskToleranceOwner,
                'riskTolerancevalue': riskTolerancevalue,
            })
        }
    }

    handleListSelect = (key, value, index) => {
        //console.log(key, value)
        //let newdata = this.state[key] ? this.state[key] : []
        //newdata.push(value)
        console.log(key+index+':'+value)
        this.setState((state)=>{ this.state[key][index] = value }, ()=>{
            this.props.submitChange(key, this.state[key])
        })
    };

    handleAddNew = (event) => {
        // get the type (as data-value in the dom element), here need to use its parent, because the event target return only the button not its wrapper
        //console.log(event.target.parentNode.dataset)
        //console.log(event.target.parentNode)
        let updateList = this.state.RiskTolerance
        //console.log(this.state)
        //console.log(type)
        //console.log(updateList)
        updateList.push("")
        //console.log(updateList)
        this.setState({RiskTolerance: updateList}, ()=>{
            this.props.submitChange('riskTolerance', updateList)
        })
    }
    
    handleChange = (name) => event => {
        let newdata = this.state[name]
        newdata = (event.target.checked ? '✔' : null)
        this.setState({ [name]: newdata },()=>{
            this.props.submitRiskChange(name, this.state[name])
        })
        //console.log(name)
    };

    handleTextChange = (name, index, event) => {
        //console.log(this.Risk_info_temp)
        let value = event.target.value
        this.setState((state)=>{
            this.state[name][index] = value
            this.props.submitChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleRiskAppetiteStatementChange = (name, event) => {
        //console.log(this.Risk_info_temp)
        let value = event.target.value
        console.log(this.state.name)
        console.log(value)
        this.setState({
            [name]: value
        }, ()=>{
            this.props.submitRiskChange(name, this.state[name])
        })
        this.forceUpdate()
    };

    handleDrop = (event) => {

        let index = event.target.parentNode.dataset.index
        // if click on the border of the button, it returns the parents........
        if (index == null) {
            index = event.target.dataset.index
        }
        console.log(index)
        let updateListRiskTolerance = this.state.RiskTolerance
        let updateListriskToleranceNo = this.state.riskToleranceNo
        let updateListriskToleranceDescription = this.state.riskToleranceDescription
        let updateListriskToleranceOwner = this.state.riskToleranceOwner
        let updateListriskTolerancevalue = this.state.riskTolerancevalue


        updateListRiskTolerance.splice(index, 1)
        updateListriskToleranceNo.splice(index, 1)
        updateListriskToleranceDescription.splice(index, 1)
        updateListriskToleranceOwner.splice(index, 1)
        updateListriskTolerancevalue.splice(index, 1)

        this.setState({
            RiskTolerance: updateListRiskTolerance,
            riskToleranceNo: updateListriskToleranceNo,
            riskToleranceDescription: updateListriskToleranceDescription,
            riskToleranceOwner: updateListriskToleranceOwner,
            riskTolerancevalue: updateListriskTolerancevalue
        }, ()=>{
            this.props.submitChange('RiskTolerance', updateListRiskTolerance)
            this.props.submitChange('riskToleranceNo', updateListriskToleranceNo)
            this.props.submitChange('riskToleranceDescription', updateListriskToleranceDescription)
            this.props.submitChange('riskToleranceOwner', updateListriskToleranceOwner)
            this.props.submitChange('riskTolerancevalue', updateListriskTolerancevalue)
        })
    }

    render() {
        const { classes } = this.props;
        let namelist = []
        for (let list in this.props.employee) {
            namelist.push(this.props.employee[list].name + ', ' + this.props.employee[list].designation)
        }
        let KRIFrequencyOption = ['Annually', 'Monthly', 'Daily']
        //console.log(this.state.kri)


        const filters = (filterdata)=>{
            let filterJSX = []
            for (var filter in filterdata) {
                filterJSX.push(
                    <div style={{ textAlign: 'left', paddingLeft: '10px'}}>
                        <Typography variant='h7' style={{ display: 'inline-block', minWidth: '120px'}}> {filter} </Typography>
                        {filterdata[filter].map((data)=>{
    
                            return (
                                <div style={{display:'inline-block', textAlign:'left', minWidth:'120px'}}>
                                    <Checkbox
                                        checked={this.state[data] == "✔"}
                                        onChange={this.handleChange(data)}
                                        value={data}
                                        color='primary'
                                    />
                                    <typography> {data} </typography>
                                </div>
                            )
                        })}
                    </div>
                )
            }
            return filterJSX
        }
    
        const RiskAppetitecheckboxSelection = filters(this.state.AppetiteToleranceCheckBox)
    
        const AppetiteTable =  (
            <div>
                <Table padding='dense'>
                    <TableHead>
                        <TableRow style={{height:'40px'}}>
        
                            <TableCell align = 'center' rowSpan={2} > No </TableCell>
                            <TableCell align = 'center' rowSpan={2} > Risk Tolerance </TableCell>
                            <TableCell align = 'center' rowSpan={2} > KRI Owner </TableCell>
                            <TableCell align = 'center' colSpan={3} > Thresholds</TableCell>
                        </TableRow>
                    </TableHead>
        
                    <TableBody>
                        {this.state.RiskTolerance.map((item, index)=>{
                            return(
                                <TableRow style={{height:'40px'}}>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px' }}> 
                                        <TextField
                                            id = "riskToleranceNo"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("riskToleranceNo", index, event)}
                                            value = {this.state.riskToleranceNo[index]}
                                            placeholder = "R1"
                                        />
                                        <Button
                                            data-index={index}
                                            variant='outlined'
                                            color='secondary'
                                            className={classes.button}
                                            onClick= {this.handleDrop}
                                        >
                                            Drop
                                        </Button>
                                    </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <TextField
                                            style= {{width: '16vw'}}
                                            id = "riskToleranceDescription"
                                            className={classes.TextFieldUnderline}
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: {overflow: "hidden" }}}
                                            multiline = {true}
                                            onChange = {(event) => this.handleTextChange("riskToleranceDescription", index, event)}
                                            value = {this.state.riskToleranceDescription[index]}
                                            placeholder = "Description"
                                        /> </TableCell>
                                    <TableCell align = 'center' style={{ padding: '10px 2px 10px 2px' }}> 
                                        <SimpleSelect index={index} id = 'riskToleranceOwner' option = {namelist} defaultoption={namelist.findIndex(item => item == this.state.riskToleranceOwner[index])} returnSelection={this.handleListSelect}/> 
                                    </TableCell>
                                    <TableCell align = 'center' style={{ width:'1%', padding: '10px 2px 10px 2px', width:"7%" }}>   
                                        <TextField
                                            id = "riskTolerancevalue"
                                            InputProps={{ style: { fontSize: 15 }}}
                                            inputProps={{ style: { textAlign: "center" }}}
                                            onChange = {(event) => this.handleTextChange("riskTolerancevalue", index, event)}
                                            value = {this.state.riskTolerancevalue[index]}
                                            placeholder = ">30%"
                                        /> 
                                    </TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
        
                </Table>
                <div className={classes.button_table_add_neww}>
                    <Button variant="outlined" color="primary" className={classes.button} onClick= {this.handleAddNew}>
                        Add New
                    </Button>
                </div>
            </div>
        )


        return(
            <MuiThemeProvider theme={theme}>
                <div>
                    <Typography  variant = "h6"  align="left" className={classes.FormHeader}> G. Risk Appetite and Tolerance </Typography>
                    <Divider className={classes.FormDivider}/>
                    <Grid container padding>
                        <Grid item md={2}>
                            <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Risk Appetite Level : </Typography>
        
                        </Grid>
                        <Grid item md={10} style={{textAlign:'center'}}>
                            {RiskAppetitecheckboxSelection}
                        </Grid>
                    </Grid>

                    <Grid container padding>
                        <Grid item md={2}>
                            <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Risk Appetite Statement : </Typography>
        
                        </Grid>
                        <Grid item md={10} style={{paddingLeft:"142px"}}>
                            <TextField
                                id = "RiskAppetiteStatement"
                                fullWidth = {true}
                                variant = "outlined"
                                multiline = {true}
                                className={classes.FormTextField}
                                onChange = {(event) => this.handleRiskAppetiteStatementChange("RiskAppetiteStatement", event)}
                                value = {this.state.RiskAppetiteStatement}
                                placeholder = "click to edit"
                            />
                        </Grid>
                    </Grid>

                    <Grid container padding>
                        <Grid item md={2}>
                            <Typography variant = "h7"  align="left" className={classes.FromSubHeader}> Risk Tolerance : </Typography>
        
                        </Grid>
                        <Grid item md={10} style={{textAlign:'center', paddingLeft:"142px"}}>
                            {AppetiteTable}
                        </Grid>
                    </Grid>
                </div>
            </MuiThemeProvider>         
        )
    }
}

export default withStyles(styles)(KRI);
    


// WEBPACK FOOTER //
// ./src/components/Risks/RiskRegisterSection/G.js